import {
  Alert,
  alpha,
  InputAdornment,
  MenuItem,
  Paper,
  Stack,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";

import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
// import { timezones } from "./fusoHorarios";

export default function EasyReportConfig() {
  const { setSubTitle, setChanges, changes, settings } = useOutletContext();
  const theme = useTheme();
  const produto = "easyreport";

  // estados de formulário
  const [timeLimit, setTimeLimit] = useState(2);

  useEffect(() => {
    setSubTitle("EasyReport");
  }, [setSubTitle]);

  useEffect(() => {
    if (!settings) return;

    let settingsData = settings.find((item) => item.produto === produto);

    if (settingsData) {
      setTimeLimit(settingsData?.configuracoes?.tempoLimite || 2);
    }
  }, [settings]);

  const styles = {
    textFieldSelect: {
      "& .MuiInputBase-input": { fontSize: "0.875rem" },
      "& .MuiOutlinedInput-root": {
        background: alpha(theme.palette.background.paper, 0.7),
        ":hover": { background: alpha(theme.palette.background.paper, 0.9) },
      },
      minWidth: "min-content",
    },
    labels: { fontSize: "14px", fontWeight: 500, color: "text.primary" },
    text: { fontSize: "0.95rem", fontWeight: 500 },
    textFine: {
      fontSize: "0.86rem",
      mt: "-2px",
      color: theme.palette.text.shadow,
    },
    boxOP: {
      backgroundColor: theme.palette.background.paper,
      border: "1px solid" + theme.palette.background.paperOutlined,
      p: 2,
      borderRadius: "5px",
    },
    textField: {
      fontSize: "14px",
      width: "100%",
      "& .MuiInputBase-input": {
        fontSize: "0.9rem",
        height: "20px!important",
      },
      '& input[type="number"]::-webkit-outer-spin-button': { display: "none" },
      '& input[type="number"]::-webkit-inner-spin-button': { display: "none" },
      '& input[type="number"]': { MozAppearance: "textfield" },
      "& .MuiOutlinedInput-root": {
        boxShadow: "none",
        "&.Mui-focused": { boxShadow: "none", border: "none" },
      },
    },
    textAdorment: {
      ml: "-5px",
      fontSize: "0.875em",
      fontWeight: 800,
      color: theme.palette.text.disabled,
      width: "max-content",
    },
    containerPredefinicoes: {
      ml: "0px",
      mr: "0px",
      p: "10px 15px",
      mt: 2,
      width: "100%",
      borderRadius: "5px",
      backgroundColor: theme.palette.background.textField,
    },
  };

  // Handler de salvar com validação

  return (
    <Stack gap={2} mb={8}>
      {/* === Link do Banco === */}
      <Paper sx={styles.boxOP}>
        <Stack direction="column">
          <Typography sx={styles.text}>Período de coleta</Typography>

          <Typography sx={{ ...styles.textFine }}>
            Informe o intervalo de tempo máximo disponível para coleta a partir
            do dia atual
          </Typography>

          <Stack justifyContent={"center"} gap={2} mt={1} direction={"row"}>
            <TextField
              fullWidth
              select
              sx={styles.textField}
              onChange={(e) => {
                setChanges((data) => ({
                  product: produto,
                  settings: {
                    ...data?.settings,
                    tempoLimite: e.target.value,
                  },
                }));
                setTimeLimit(e.target.value);
              }}
              value={timeLimit}
              size="small"
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography sx={styles.textAdorment}>
                        INTERVALO
                      </Typography>
                    </InputAdornment>
                  ),
                },
              }}
            >
              <MenuItem value={2}>2 meses</MenuItem>
              <MenuItem value={3}>3 meses</MenuItem>
            </TextField>
          </Stack>
          {changes && (
            <Alert sx={{ mt: 1 }} severity="warning">
              <strong>Atenção!</strong> Você alterou o período de coleta do
              EasyReport. É necessário que o período de coleta seja compatível
              com o período de retenção dos dados no Zabbix. Caso tenha dúvidas,
              entre em contato com o suporte para sincronizar a alteração.
            </Alert>
          )}
        </Stack>
      </Paper>
    </Stack>
  );
}
